/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/style-prop-object */
/* eslint-disable react/prop-types */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";

import ScrollContainer from "react-indiana-drag-scroll";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import MechanicsSummary from "../../components/MechanicsSummary/MechanicsSummary";
import { DEFAULT_AXIS_OPTIONS } from "../../store/data/cartesianData";
import {
  addAxisToCompare,
  resetAxesToCompare,
  selectAxesCombinations,
  selectAxesToCompare,
  selectAxisSelection,
  selectCartesianFilters,
  selectCartesianReadOnlyMode,
  selectCartesianSteps,
  selectDynamics,
  selectMechanics,
  selectSelectedAxis,
  setAxesCombinations,
  setAxesToCompare,
  setAxisOptions,
  setAxisSelection,
  setCartesianCurrentStep
} from "../../store/slices/cartesian";
import { updateConfiguration } from "../../../Common/store/slices/common";
import { getAxesCombinations } from "../../utils/api/api";
import t, { tr } from "../../../Common/utils/translation/translator";
import "./AxisSelection.scss";
import AxisSelectionFilter from "./filter/AxisSelectionFilter";
import AxisSelectionTableSection from "./AxisSelectionTableSection";
import AxisComparatorCompareSection from "./comparator/AxisComparatorCompareSection";

import Navigator from "../../../Common/layouts/Navigator/Navigator";
import { showSnackbar } from "../../../Retrofit/store/slices/retrofit";
import { useUpdateEffect } from "react-use";

const getFeedConstantValue = (data) => {
  return data.axis.driveType === "ball screw" ? data.ballscrew.ballscrewPitch : data.axis.feedConstant;
};

const productTableHeaders = [
  { name: t("cartesian.ui.axis_selection.guide_type"), sort: false, valuePath: "guideType.guideType" },
  {
    name: t("cartesian.ui.axis_selection.carriage_type"),
    sort: false,
    valuePath: "carriageType.typeOfCarriage"
  },
  {
    name: t("cartesian.ui.axis_selection.feed_constant"),
    sort: false,
    unit: "mm/rev",
    valuePath: getFeedConstantValue
  }
];

const technicalFeaturesTableHeaders = [
  {
    name: t("cartesian.ui.axis_selection.mechanical_drive_element"),
    sort: false,
    valuePath: "axis.driveType"
  },
  {
    name: t("cartesian.ui.axis_selection.repeatability"),
    sort: false,
    unit: "±",
    valuePath: "axis.repeatability"
  },
  {
    name: t("cartesian.ui.axis_selection.axis_profile"),
    sort: false,
    subHeaders: [
      { name: t("cartesian.ui.axis_selection.width"), unit: "mm", valuePath: "axisProfile.width" },
      { name: t("cartesian.ui.axis_selection.height"), unit: "mm", valuePath: "axisProfile.height" }
    ]
  },
  {
    name: t("cartesian.ui.dynamics.carriage"),
    sort: false,
    subHeaders: [
      {
        name: t("cartesian.ui.axis_selection.length"),
        unit: "mm",
        valuePath: "carriageType.lenghtCommercialReference"
      },
      {
        name: t("cartesian.ui.axis_selection.weight"),
        unit: "kg",
        valuePath:
          "data.coverstrip?calculations.totalAxisWeightPreCalculations.preCalcWeightCarriageWcoverstrip:calculations.totalAxisWeightPreCalculations.preCalcWeightCarriageWoCoverstrip"
      }
    ]
  },
  {
    name: t("cartesian.ui.axis_selection.total_axis"),
    sort: false,
    subHeaders: [
      {
        name: t("cartesian.ui.axis_selection.length"),
        unit: "mm",
        valuePath: "calculations.axisLength"
      },
      {
        name: t("cartesian.ui.axis_selection.weight"),
        unit: "kg",
        valuePath: "calculations.axisWeight"
      }
    ]
  }
];

const performanceOverviewTableHeaders = [
  {
    name: t("cartesian.ui.axis_selection.utilization_mechanical_drive_torque"),
    sort: false,
    unit: "%",
    valuePath: "calculations.driveTorqueUtilization"
  },
  {
    name: t("cartesian.ui.axis_selection.utilization_speed"),
    sort: false,
    unit: "%",
    valuePath: "calculations.speedAxisUtilization"
  }
];

const getGuidingSystemTableHeaders = (numberOfCarriage) => {
  const guidingSystemTableHeaders = [];
  for (let i = 0; i < numberOfCarriage; i++) {
    guidingSystemTableHeaders.push({
      name: t("cartesian.ui.dynamics.carriage") + " " + (i + 1),
      sort: false,
      valuePath: "",
      subHeaders: [
        {
          name: t("cartesian.ui.axis_selection.utilization"),
          unit: "%",
          valuePath: "calculations.precalcKFactorCarriage[" + i + "]"
        },
        {
          name: t("cartesian.ui.axis_selection.service_life"),
          unit: t("cartesian.ui.axis_selection.years"),
          valuePath: "calculations.serviceLifeYearsCarriage[" + i + "]"
        }
      ]
    });
  }
  return guidingSystemTableHeaders;
};

const AxisSelection = ({ ...props }) => {
  const filters = useSelector(selectCartesianFilters);
  const [showCompare, setShowCompare] = useState(false);
  const axesToCompare = useSelector(selectAxesToCompare);
  const axisSelection = useSelector(selectAxisSelection);
  const selectedAxis = useSelector(selectSelectedAxis);
  const steps = useSelector(selectCartesianSteps);
  const mechanics = useSelector(selectMechanics);
  const dynamics = useSelector(selectDynamics);
  const axesCombinations = useSelector(selectAxesCombinations);
  const INIT_PAGING = {
    skip: 0,
    limit: 30
  };
  const [paging, setPaging] = useState(INIT_PAGING);
  const isReadOnly = useSelector(selectCartesianReadOnlyMode);
  const dispatch = useDispatch();

  const handleContinue = () => {
    if (axisSelection.isValid || axesToCompare?.length === 1) {
      onSelectAxis(axesToCompare[0]);
    } else {
      dispatch(
        showSnackbar({
          id: "MISSING_OR_INCORRECT_FIELD"
        })
      );
    }
  };

  const handlePrevious = () => {
    dispatch(setCartesianCurrentStep(steps.DYNAMICS));
    dispatch(updateConfiguration());
  };

  const groupByAxisGCR = (axisCombinations) => {
    return axisCombinations.reduce((acc, current) => {
      const { axisGCR } = current.axis;
      if (!acc[axisGCR]) {
        acc[axisGCR] = [];
      }
      acc[axisGCR].push(current);
      return acc;
    }, {});
  };

  const onSelectAxis = (axis) => {
    let axisChanged = false;
    if (axisSelection?.selectedAxis?.id !== axis.id) {
      axisChanged = true;
      dispatch(setAxisOptions(DEFAULT_AXIS_OPTIONS));
    }
    dispatch(
      setAxisSelection({
        ...axisSelection,
        selectedAxis: axis,
        isValid: true
      })
    );
    dispatch(setAxesToCompare([axis]));
    setShowCompare(false);
    dispatch(updateConfiguration());
    // go to the next step
    if (!isReadOnly || !axisChanged) {
      dispatch(setCartesianCurrentStep(steps.AXIS_OPTIONS));
    }
  };

  const handleRemoveSolutionFromCompare = (axis) => {
    var axesToCompareTmp = [...axesToCompare];
    axesToCompareTmp = axesToCompareTmp.filter((a) => a.id !== axis.id);
    if (axesToCompareTmp.length <= 1) {
      setShowCompare(false);
    }
    if (axisSelection.selectedAxis && axis.id === axisSelection.selectedAxis.id) {
      dispatch(setCartesianCurrentStep(steps.AXIS_SELECTION));
      dispatch(setAxisOptions(DEFAULT_AXIS_OPTIONS));
      dispatch(setAxisSelection({ ...axisSelection, selectedAxis: null, isValid: false }));
    }
    dispatch(setAxesToCompare(axesToCompareTmp));
  };

  if (!axesCombinations && axisSelection.selectedAxis) {
    const axisGroupByAxisGCR = groupByAxisGCR([axisSelection.selectedAxis]);
    dispatch(setAxesCombinations({ countOfResults: 1, axes: axisGroupByAxisGCR }));
  }

  const {
    isLoading: isLoadingGetAxesCombinations,
    isFetching: isFetchingGetAxesCombinations,
    refetch: fetchAxesCombinations
  } = useQuery(
    "Get axes combinations",
    async () => {
      try {
        const result = await getAxesCombinations({
          locale: "en-WW",
          paging,
          search: filters,
          mechanics: mechanics || {},
          dynamics: dynamics || {},
          order: {}
        });
        const groupedResults = groupByAxisGCR(result?.axisCombinationsFiltered);
        dispatch(setAxesCombinations({ countOfResults: result?.countOfResults, axes: groupedResults }));
        return groupedResults;
      } catch (error) {
        console.error("ERR", error);
      }
      return undefined;
    },
    {
      enabled: false
    }
  );

  useUpdateEffect(() => {
    fetchAxesCombinations();
  }, [paging]);

  useEffect(() => {
    if (selectedAxis && axesToCompare.length === 0) {
      dispatch(setAxesToCompare([selectedAxis]));
    }
  }, []);

  return (
    <div className="AxisSelection space-y-3" {...props}>
      <div className="flex flex-col w-full bg-white z-50">
        <MechanicsSummary data-testid="mechanics-summary" />
        <AxisSelectionFilter
          refetchAxesCombinations={() => {
            dispatch(setCartesianCurrentStep(steps.AXIS_SELECTION));
            dispatch(setAxisOptions(DEFAULT_AXIS_OPTIONS));
            dispatch(setAxisSelection({ ...axisSelection, selectedAxis: null, isValid: false }));
            setPaging({ ...INIT_PAGING });
          }}
          resetAxesToCompare={resetAxesToCompare}
        />
      </div>
      <div className="flex flex-col bg-white">
        {(axesCombinations || isLoadingGetAxesCombinations || isFetchingGetAxesCombinations) && (
          <ScrollContainer hideScrollbars={false}>
            <AxisSelectionTableSection
              data-testid="axis-selection-table-section"
              axesCombinations={axesCombinations?.axes}
              isLoadingOrFetching={isLoadingGetAxesCombinations || isFetchingGetAxesCombinations}
              countOfResults={axesCombinations?.countOfResults}
              paging={paging}
              setPaging={setPaging}
              mechanics={mechanics}
              selectedAxis={selectedAxis}
              axesToCompare={axesToCompare}
              axisSelection={axisSelection}
              steps={steps}
              productTableHeaders={productTableHeaders}
              technicalFeaturesTableHeaders={technicalFeaturesTableHeaders}
              performanceOverviewTableHeaders={performanceOverviewTableHeaders}
              getGuidingSystemTableHeaders={getGuidingSystemTableHeaders}
              setCartesianCurrentStep={setCartesianCurrentStep}
              setAxisOptions={setAxisOptions}
              setAxisSelection={setAxisSelection}
              addAxisToCompare={addAxisToCompare}
            />
          </ScrollContainer>
        )}
        {showCompare && (
          <AxisComparatorCompareSection
            data-testid="compare-section"
            mechanics={mechanics}
            compareDatas={axesToCompare}
            onClose={() => setShowCompare(false)}
            onSelect={(axis) => {
              onSelectAxis(axis);
            }}
            onRemoveSolutionFromCompare={(axis) => {
              handleRemoveSolutionFromCompare(axis);
            }}
            resetAxesToCompare={resetAxesToCompare}
          />
        )}
      </div>
      <Navigator
        continueLabel={
          axesToCompare?.length > 1
            ? tr("msizer.ui.compare.compare_n_axes", { n: axesToCompare?.length })
            : t("msizer.ui.compare.select_axis")
        }
        continueAction={() => {
          if (axesToCompare?.length === 1) {
            handleContinue();
          } else {
            setShowCompare(true);
          }
        }}
        continueButtonDisabled={axesToCompare?.length === 0 && !axisSelection.isValid}
        previousAction={() => {
          handlePrevious();
        }}
      />
    </div>
  );
};

export default AxisSelection;
